// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".errormessage[data-v-21f92e6a]{color:#e53935;font-size:1.2rem;text-align:left}.bordered[data-v-21f92e6a]{border:1px solid #e53935;font-weight:700;background-color:#fbe1e1;padding:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
